import { useState } from 'react'
import {
  CreateNewContactModal,
  EditContactModal,
  HandleEditContactModal,
  ContactDeleteModal,
  HandleDeleteContactModal
} from '../Types/types'
import { AnalyticEvent } from '../../analytics/GoogleAnalytics'

export function useCreateContactModal() {
  const [createNewContactModal, setVisible] = useState<CreateNewContactModal>(false)

  const handleCreateNewContactModal = () => {
    if (!createNewContactModal) {
      AnalyticEvent('Contacts', 'CreateNewContactButtonPress')
    }
    setVisible(!createNewContactModal)
  }

  return { createNewContactModal, handleCreateNewContactModal }
}

export function useEditContactModal() {
  const [editContactModal, setVisible] = useState<EditContactModal>(false)

  const handleEditContactModal: HandleEditContactModal = () => {
    if (!editContactModal) {
      AnalyticEvent('Contacts', 'EditContactButtonPress')
    }
    setVisible(!editContactModal)
  }

  return { editContactModal, handleEditContactModal }
}

export function useDeleteContactModal() {
  const [contactDeleteModal, setVisible] = useState<ContactDeleteModal>(false)

  const handleDeleteContactModal: HandleDeleteContactModal = () => {
    if (!contactDeleteModal) {
      AnalyticEvent('Contacts', 'DeleteContactButtonPress')
    }
    setVisible(!contactDeleteModal)
  }

  return { contactDeleteModal, handleDeleteContactModal }
}
